import { createContext, useContext } from 'react';
import type { FillerPreviewSources } from '@/lib/preview/fillerPreviewSources';

// null is the export/default path. Only the browser Player opts into proxies
// and native video; no URL substitutions ever enter saved/exported layouts.
export const FillerPreviewContext = createContext<FillerPreviewSources | null>(null);
export const useFillerPreviewContext = () => useContext(FillerPreviewContext);
export const EMPTY_FILLER_PREVIEWS: FillerPreviewSources = {};
